import styled from 'styled-components';

const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.palette.primary.soft};
  &::after {
    content: '';
    display: block;
    width: 0%;
    width: ${({ rate }) => `${rate * 100}%`};
    height: 100%;
    background-color: ${({ theme }) => theme.palette.primary.light};
    transition: width 0.5s;
  }
`;

export default ProgressBar;
